export const SERVICE_PACKAGE = '套餐' // 套餐
export const WASHING = '洗车'// 洗车
export const MAINTENANCE = '保养' // 保养
export const BEAUTY = '美容' // 美容
export const REPAIR = '维修' // 维修



// WEBPACK FOOTER //
// ./src/constants/terms/service-types.js